export default [
  {
    path: '/rent/v2/agreement',
    name: 'agreement',
    component: () => import('@/pages/agreement/index'),
    meta: { title: '协议', requireAuth: true },
    children: [
      {
        path: 'userprivate',
        name: 'userprivate',
        component: () => import('@/pages/agreement/userAndPrivate'),
        meta: { title: '用户隐私协议', requireAuth: true },
      },
      {
        path: 'user',
        name: 'user',
        component: () => import('@/pages/agreement/user'),
        meta: { title: '用户使用协议', requireAuth: true },
      },
      {
        path: 'private',
        name: 'private',
        component: () => import('@/pages/agreement/private'),
        meta: { title: '隐私政策', requireAuth: true },
      },
      {
        path: 'childRule',
        name: 'childRule',
        component: () => import('@/pages/agreement/childRule'),
        meta: { title: '儿童个人信息保护规则', requireAuth: true },
      },
      {
        path: 'sdzAgr',
        name: 'sdzAgr',
        component: () => import('@/pages/agreement/sdzAgr'),
        meta: { title: '水电桩租赁协议', requireAuth: true },
      },
      {
        path: 'sdzUseDesc',
        name: 'sdzUseDesc',
        component: () => import('@/pages/agreement/sdzUseDesc'),
        meta: { title: '水电桩使用说明', requireAuth: true },
      },
      {
        path: 'signInRule',
        name: 'signInRule',
        component: () => import('@/pages/agreement/signInRule'),
        meta: { title: '签到规则', requireAuth: true },
      },
      {
        path: 'fcgjOrderRule',
        name: 'fcgjOrderRule',
        component: () => import('@/pages/agreement/fcgjNeddKnow'),
        meta: { title: '预定须知', requireAuth: true },
      },
      {
        path: 'campsite',
        name: 'campsiteAgr',
        component: () => import('@/pages/agreement/campsiteAgr'),
        meta: { title: '预定须知', requireAuth: true },
      },
      {
        path: 'userInfoCollectList',
        name: 'userInfoCollectList',
        component: () => import('@/pages/agreement/userInfoCollectList'),
        meta: { title: '个人信息收集及使用清单', requireAuth: true },
      },
      {
        path: 'sdkUseList',
        name: 'sdkUseList',
        component: () => import('@/pages/agreement/sdkUseList'),
        meta: { title: 'SDK共享清单与第三方共享清单', requireAuth: true },
      }
    ]
  },
]


// WEBPACK FOOTER //
// ./src/pages/agreement/agreement.js